import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import { formatDefaultInfoUnitDetail } from './fm1-01-default-info-unit.helper';
import { Fm1_01DefaultInfoUnitActions } from './fm1-01-default-info-unit.redux';
import { TPayloadGetDefaultInfoUnitDetailRequest } from './fm1-01-default-info-unit.type';

export function* getDefaultInfoUnitDetail(
	action: PayloadAction<TPayloadGetDefaultInfoUnitDetailRequest>
) {
	const { prefix, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.TGetDefaultInfoUnitResponse> =
			yield API.getUnitBasicInfo(prefix);
		const defaultInfoUnitDetail = formatDefaultInfoUnitDetail(res?.data);
		yield put(
			Fm1_01DefaultInfoUnitActions.getDefaultInfoUnitDetailSuccess({
				defaultInfoUnitDetail,
			})
		);

		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(Fm1_01DefaultInfoUnitActions.getDefaultInfoUnitDetailFailure());
	}
}
